import React, { useState, useEffect } from "react";
import CampaignsTable from "./components/CampaignsTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { updateObject } from "../../../helpers/updateObject";
import Notification from "./modals/Notification"

export default function Campaigns() {
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);

  const [showNotification, setShowNotification] = useState(false);


  function handleChange() {
    setShowFilter((key) => !key);
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [campaign, setCampaign] = useState({});
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [campaignId, setCampaignId] = useState(null);
  const [deleteCampaignsIds, setDeleteCampaignsIds] = useState([]);
  const [filter, setFilter] = useState(false);

  const [filterInputs, setFilterInputs] = useState({
    partnerName: "",
    campaignName: "",
    discountPercent: "",
    expireDate: "",
  });

  const [partners, setPartners] = useState([]);
  const [campaignCategories, setCampaignCategories] = useState([]);
  const [dataItemId, setDataItemId] = useState("");
  // const [dataItemNotification, setDataItemNotification] = useState("");
  const [orders, setOrders] = useState([]);

  const [specialOrders, setSpecialOrders] = useState([]);



  const onCampaigns = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}campaign?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);

          // console.log(data)
        }

      ).catch((error) => {
        setIsLoaded(false);
        setError(true);
        setRows([]);
        setCount(0);
      });
  };




  const onFilter = (skip, take, sortField, orderBy, filterInputs) => {
    setIsLoaded(true);
    const {
      partnerName,
      campaignName,
      discountPercent,
      expireDate,
    } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}campaign/filter?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}&PartnerName=${partnerName}&CampaignName=${campaignName}&DiscountPercent=${discountPercent}&ExpireDate=${expireDate}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };



  const onCampaignChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/${id}`)
      .then(({ data }) => {
        setCampaign(data);

        // console.log(data.id)
        // setDataItemId(data.id)
      });
  };



  // const onNotificationChoose = () => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}campaign/changeNotificationStatus`)
  //     .then(({ id }) => {
  //       setCampaign(id);
  //     });
  // };


  // const onNotificationChoose = (id) => {
  //   axios
  //     .put(
  //       `${process.env.REACT_APP_API_URL}campaign/changeNotificationStatus`,
  //       {
  //         id,
  //       },
  //       {
  //         headers: {
  //           "x-requestid": uuid(),
  //         },
  //       }
  //     )
  //     .then(() => {
  //       onCampaigns(skip, take, sortField, orderBy);
  //     });
  // };



  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}campaign/active`,
        {
          id,
          isActive,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onCampaigns(skip, take, sortField, orderBy);
      });
  };

  const onDeleteCampaigns = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}campaign`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteCampaignsIds,
        },
      })
      .then((res) => {
        setDeleteCampaignsIds([]);
        onCampaigns(skip, take, sortField, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.name]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  const onPartners = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}partner`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setPartners(data);
      });
  };

  const onCampaignCategories = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/category`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setCampaignCategories(data);
      });
  };

  // console.log(dataItemId)


  useEffect(() => {
    onPartners();
    onCampaignCategories();
  }, []);

  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortField, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onCampaigns(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, filter, filterInputs]);

  useEffect(() => {
    if (!showView || !showEdit) setCampaign({});
  }, [showView, showEdit]);

  const onCampaignsExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Campaign.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };





  const onOrders = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/campaignOrdersNew?categoryId=${campaign?.campaignCategoryId}`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setOrders(data);
        // console.log(data)
      });
  };

  useEffect(() => {
    onOrders(campaign?.campaignCategoryId);
  }, [campaign?.campaignCategoryId]);




  const onSpecialOrders = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/specialOrders`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setSpecialOrders(data);
    
      });
  };

  useEffect(() => {
    onSpecialOrders();
  }, []);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4  fixed-title">
        <h1 className="display-4 mb-0">Campaigns</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <CampaignsTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        setOpenRemove={setShowRemove}
        setOpenCreate={setShowCreate}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        onCampaignChoose={onCampaignChoose}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUserStatus={onUpdateUserStatus}
        setCampaignId={setCampaignId}
        setDeleteCampaignsID={setDeleteCampaignsIds}
        deleteCampaignsIds={deleteCampaignsIds}
        onDeleteCampaigns={onDeleteCampaigns}
        onCampaignsExport={onCampaignsExport}
        // onNotificationChoose={onNotificationChoose}

        setOpenNotification={setShowNotification}


        setDataItemId={setDataItemId}
        dataItemId={dataItemId}

      />
      <Edit
        campaign={campaign}
        show={showEdit}
        onHide={setShowEdit}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onCampaigns={onCampaigns}
        partners={partners}
        campaignCategories={campaignCategories}
        orders={orders}

        setOrders={setOrders}

        specialOrders={specialOrders}

      />
      <View campaign={campaign} open={showView} onClose={toggleDrawer(false)} />
      <Delete
        id={campaignId}
        show={showRemove}
        onHide={setShowRemove}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onCampaigns={onCampaigns}
      />
      <Create
        show={showCreate}
        onHide={setShowCreate}
        onCampaigns={onCampaigns}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        partners={partners}
        campaignCategories={campaignCategories}
        dataItemId={dataItemId}
      />

      <Notification
        show={showNotification}
        onHide={setShowNotification}
        onCampaigns={onCampaigns}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        dataItemId={dataItemId}

        onCampaignChoose={onCampaignChoose}
      />


      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
    </div>
  );
}
